import React, { ComponentType } from 'react';
import { CardFormat } from '../../../../components/Card';
import { Row } from '../../../../components/Grid';
import { ContentHeader } from '../../../../components/layout/ContentHeader';
import Teaser from '../../../../components/layout/Teaser';
import { Section } from '../../../../components/Section';
import {
  Typo3Image,
  Typo3Link
} from '../../../../provider/Typo3Provider/types';

interface TeaserProps {
  header?: string;
  subheader?: string;
  files?: { image: (Typo3Image & Typo3Link)[] };
}

const mkTeaser = (format: CardFormat) => {
  const TeaserComponent = ({
    header,
    subheader,
    files = { image: [] }
  }: TeaserProps) => (
    <Section>
      <ContentHeader header={header} subheader={subheader} />
      <Row>
        <Teaser teasers={files.image || []} format={format} />
      </Row>
    </Section>
  );
  TeaserComponent.displayName = `Teaser${format
    .charAt(0)
    .toUpperCase()}${format.substr(1).toLowerCase()}`;
  return TeaserComponent;
};

export const TeaserCircle: ComponentType<TeaserProps> = mkTeaser('circle');

export const TeaserSquare: ComponentType<TeaserProps> = mkTeaser('square');
